import { render, staticRenderFns } from "./FormalEvaluationList.vue?vue&type=template&id=4d3eaab4&scoped=true&"
import script from "./FormalEvaluationList.vue?vue&type=script&lang=js&"
export * from "./FormalEvaluationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3eaab4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardTitle})
